export const simMapping: Record<string, string> = {
  basic: 'Classique',
  esim: 'eSIM',
  free: 'Disponible',
};
